import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { AppContext } from "../../Context";
import NeuronalPlayerBar from "../NeuronalPlayerBar";
import ResponsiveNavbar from "../ResponsiveNavbar";
import ChatNotificationsListener from "../ChatNotificationsListener";
import "./index.scss";

function Layout({ children }) {
  const { currentUser, isAudioPlayerActive } = useContext(AppContext);
  const location = useLocation();
  const isStudent = Boolean(currentUser && currentUser.isMaster !== true && currentUser.teacher !== true);
  const isChatRoute = location.pathname === "/chat";
  const layoutClassName = [
    "layout-container",
    isStudent && isAudioPlayerActive ? "layout-container--with-neural-player" : "",
    isChatRoute ? "layout-container--chat" : "",
  ].filter(Boolean).join(" ");

  return (
    <>
      <ChatNotificationsListener userId={currentUser?.uid} />
      <ResponsiveNavbar />

      <div className={layoutClassName}>
        {children}
      </div>

      <NeuronalPlayerBar />
    </>
  );
}

export { Layout };
